/**
 * R2 asset URL builder.
 *
 * S-072 / FEAT-006 (Phase 9). Image assets are stored in Cloudflare
 * R2 and served by the Hono API at `GET /assets/:id` (no auth — UUIDs
 * are unguessable per the FEAT-004 spec § Assets). Supported query
 * params:
 *
 *   - width — passed straight through; the route caps at 4096
 *   - fit   — `cover | contain | inside` (no `outside`; route falls back
 *     to `inside` when missing)
 *
 * `quality` and `height` are not honored by the assets route; they
 * are silently dropped.
 *
 * `fileId` may be null/undefined; an empty string is returned so the
 * <img> tag still renders without a broken-image icon (consumers should
 * check for empty before rendering).
 */

import { API_BASE_URL } from "./api";

export interface AssetUrlOptions {
  width?: number;
  fit?: "cover" | "contain" | "inside";
}

export function r2AssetUrl(
  fileId: string | null | undefined,
  opts?: AssetUrlOptions
): string {
  if (!fileId) return "";
  const params = new URLSearchParams();
  if (opts?.width) params.set("width", String(Math.min(opts.width, 4096)));
  if (opts?.fit) params.set("fit", opts.fit);
  const qs = params.toString();
  return `${API_BASE_URL}/assets/${fileId}${qs ? `?${qs}` : ""}`;
}
